import {
  Backdrop,
  BackdropRoot,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  ThemeProvider,
  TextareaAutosize,
  Autocomplete,
} from "@mui/material";
import React, { useEffect, useMemo, useState, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import { useFormik } from "formik";
import * as yup from "yup";
import CancelIcon from "@mui/icons-material/Cancel";
import { createTheme } from "@mui/material/styles";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { common_axios } from "../../../../App";
import { toast } from "react-toastify";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import Loader from "../../../../components/Loader";
import {
  useAsyncDebounce,
  useBlockLayout,
  useColumnOrder,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";
import DeleteIcon from "@mui/icons-material/Delete";
import ColumnFilter from "../../Reacttable/UserManagement/ReactTableFiles/ColumnFilter";
import axios from "axios";
import { dateFormatter } from "../../../../helper/helper";
import Swal from "sweetalert2";

export default function AddTemplateStatic() {
  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: {
            color: "red",
          },
        },
      },
    },
  });

  const [open, setOpen] = useState(false);

  const [data, setData] = useState([]);
  const [data1, setData1] = useState([]);
  const [data2, setData2] = useState([]);
  const [selectionRange, setSelectionRange] = useState(0);
  const [variableUsed, setVariableUsed] = useState([]);

  const validationSchema = yup.object({
    // templateType: yup.string().required("templateType is required!"),
    selectValue: yup.string().required("selectValue is required!"),
    selectLang: yup.string().required("selectLang is required!"),
    templateName: yup
      .string()
      .required("Template Name is required!")
      .min(3, "Template Name should be of minimum 3 characters length")
      .max(50, "Template Name be of maximum 50 characters length"),
    templateDesc: yup
      .string()
      // .required("Template  is required!")
      .min(3, "Template  should be of minimum 3 characters length")
      .max(10000, "Template  be of maximum 1000 characters length"),
    // dltTemplateId: yup
    //   .string("Enter your DLT Template Id")
    //   .min(3, "DLT Template Id should be of minimum 3 characters length")
    //   .max(20, "DLT Template Id should be of maximum 20 characters length"),
    assignUser: yup.object().nullable(),
    // dltId: yup
    //   .string("Enter your DLT PE Id")
    //   .min(3, "DLT PE Id should be of minimum 3 characters length")
    //   .max(20, "DLT PE Id should be of maximum 20 characters length"),
  });

  const enterVal = async () => {
    let textToInsert = "#var#";

    let cursorPosition = await selectionRange;
    let textBeforeCursorPosition = await textareaRef.current.value.substring(
      0,
      cursorPosition
    );

    let textAfterCursorPosition = await textareaRef.current.value.substring(
      cursorPosition,
      textareaRef.current.value.length
    );

    if (textBeforeCursorPosition.slice(-1) != " ") {
      formik.setFieldValue(
        "templateDesc",
        textBeforeCursorPosition + " " + textToInsert + textAfterCursorPosition
      );
    } else {
      formik.setFieldValue(
        "templateDesc",
        textBeforeCursorPosition + textToInsert + textAfterCursorPosition
      );
    }

    // textareaRef.current.value =
    //   textBeforeCursorPosition + " " + textToInsert + textAfterCursorPosition;

    // setVariableUsed([...variableUsed, textToInsert]);

    // textareaRef.current.focus();
  };

  const onBlur = async (e) => {
    await setSelectionRange(e.target.selectionStart);
    await setVariableUsed([...variableUsed, "#var#"]);
  };

  const formik = useFormik({
    initialValues: {
      // templateType: "",
      templateName: "",
      templateDesc: "",
      dltTemplateId: "",
      dltId: "",
      assignUser: null,
      selectValue: "",
      selectLang: "",
    },

    onReset: (initialValues) => ({
      values: { initialValues },
    }),
    validateOnChange: true,

    validationSchema: validationSchema,

    onSubmit: async (values) => {
      KeywordCheckApi(values);  
    },
  });
// ....................................KeywordCheckApi......................................................//

async function KeywordCheckApi(values) {
  // console.log("first");
  try {
    setOpen(true);

    const result = await common_axios.post(
      `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/keywords/v2/check`,
      {
        keywordRequest:{
    
            keyword:values.templateDesc,
        }
    }
      // `http://192.168.167.66:4900/user/phone-books/v1/list`
    );

    if (result.data.statusDescription.statusCode == 200) {
      
      // formik.handleReset();
          setOpen(false);
          TemplatePostApi(values)
    
    } else {
      setOpen(false);

      // await toast.error(res.data.statusDescription.statusMessage, {
      //   theme: "colored",
      // });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: result.data.statusDescription.statusdescription,
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  } catch (error) {
    // console.log(error);
    setOpen(false);

    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something went wrong",
      // footer: '<a href="">Why do I have this issue?</a>'
    });
  }
}
// ........................................TemplatePost......................................................//



async function TemplatePostApi(values) {
  // console.log("first");
  try {
    setOpen(true);
    const res = await common_axios.post(
      `${process.env.REACT_APP_COMMON_API_SENDER_ID}/admin/template/v1/create`,
      {
        language: {
          lang: values.selectLang,
        },
        unicode: values.selectLang == "English" ? 0 : 1,
        userId: values.assignUser?.uid || localStorage.getItem("UserId"),
        createdFor: values.assignUser?.username,
        templateName: values.templateName,
        // dltId: values.dltId,
        // templateDltId: values.dltTemplateId,
        // telemarketerId: values.dltId,
        templateDescription: values.templateDesc,
        category: values.selectValue,
        createdBy: localStorage.getItem("usernamedisplayed"),
        resellerId:
          JSON.parse(localStorage.getItem("Sidebaritems")).name ==
          "ROLE_RESELLER"
            ? localStorage.getItem("UserId")
            : null,
        status: true,
        // templateType: values.templateType,
      }
    );

    if (res.data.statusDescription.statusCode == 200) {
      formik.handleReset();
      res.data.templateModel.createdOn = await String(
        new Date(res.data.templateModel.createdOn)
      );

      await setData([...data, res.data.templateModel]);
      setOpen(false);

      // await toast.success("Created Successfully", {
      //   theme: "colored",
      // });
      Swal.fire({
        icon: "success",
        //  title: "Oops...",
        text: "Created SuccessFully",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    } else {
      setOpen(false);

      // await toast.error(res.data.statusDescription.statusMessage, {
      //   theme: "colored",
      // });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: res.data.statusDescription.statusMessage,
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  } catch (error) {
    // console.log(error);
    setOpen(false);

    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something went wrong",
      // footer: '<a href="">Why do I have this issue?</a>'
    });
  }
}








  const columns = useMemo(
    () =>
      JSON.parse(localStorage.getItem("Sidebaritems")).name == "ROLE_RESELLER"
        ? [
          {
            Header: "Id",
            accessor: "id",
            Cell: (cell ) => (
             <>{cell.row.index +1}</>
            ),
          },,
            // {
            //   Header: "DLT PE Id",

            //   accessor: "dltId", // accessor is the "key" in the data
            // },
            // {
            //   Header: "DLT Template Id",

            //   accessor: "templateDltId", // accessor is the "key" in the data
            // },
            {
              Header: "Template",

              accessor: "templateName", // accessor is the "key" in the data
            },
            {
              Header: "Created by",

              accessor: "createdBy", // accessor is the "key" in the data
            },
            {
              Header: "Created For",

              accessor: "createdFor", // accessor is the "key" in the data
            },

            // {
            //   Header: "Template Type",

            //   accessor: "templateType", // accessor is the "key" in the data
            // },
            {
              Header: "Category",

              accessor: "category", // accessor is the "key" in the data
            },
            {
              Header: "Language",

              accessor: "language.lang", // accessor is the "key" in the data
            },
            {
              Header: "Unicode",

              accessor: "unicode", // accessor is the "key" in the data
              Cell: (cell) => {
                return (
                  <>
                    {cell.row.original.unicode == 0 ? (
                      <CancelIcon color="red" sx={{ color: "red" }} />
                    ) : (
                      <CheckCircleIcon color="green" sx={{ color: "green" }} />
                    )}
                  </>
                );
              },
            },

            {
              Header: "Status",

              accessor: "approved",
              Cell: (cell) => {
                return (
                  <>
                    {cell.row.original.approved == 0 ? (
                      <div className="badge badge_8 bg-warning">Pending</div>
                    ) : (
                      <div className="badge badge_8 bg-success">Approved</div>
                    )}
                  </>
                );
              },
            },
            // {
            //   Header: "Date",

            //   accessor: "createdOn", // accessor is the "key" in the data
            //   Cell: (cell) => {
            //     return <>{dateFormatter(cell.row.original.createdOn)}</>;
            //   },
            // },
          ]
        : [
            {
              Header: "Id",

              accessor: "id", // accessor is the "key" in the data
            },
            // {
            //   Header: "DLT PE Id",

            //   accessor: "dltId", // accessor is the "key" in the data
            // },
            // {
            //   Header: "DLT Template Id",

            //   accessor: "templateDltId", // accessor is the "key" in the data
            // },
            {
              Header: "Template",

              accessor: "templateName", // accessor is the "key" in the data
            },
            {
              Header: "Created by",

              accessor: "createdBy", // accessor is the "key" in the data
            },

            // {
            //   Header: "Template Type",

            //   accessor: "templateType", // accessor is the "key" in the data
            // },
            {
              Header: "Category",

              accessor: "category", // accessor is the "key" in the data
            },
            {
              Header: "Language",

              accessor: "lang", // accessor is the "key" in the data
            },
            {
              Header: "Unicode",

              accessor: "unicode", // accessor is the "key" in the data
              Cell: (cell) => {
                return (
                  <>
                    {cell.row.original.unicode == 0 ? (
                      <CancelIcon color="red" sx={{ color: "red" }} />
                    ) : (
                      <CheckCircleIcon color="green" sx={{ color: "green" }} />
                    )}
                  </>
                );
              },
            },

            {
              Header: "Status",

              accessor: "approved",
              Cell: (cell) => {
                return (
                  <>
                    {cell.row.original.approved == 0 ? (
                      <div className="badge badge_8 bg-warning">Pending</div>
                    ) : (
                      <div className="badge badge_8 bg-success">Approved</div>
                    )}
                  </>
                );
              },
            },
            // {
            //   Header: "Date",

            //   accessor: "createdOn", // accessor is the "key" in the data
            //   Cell: (cell) => {
            //     return <>{dateFormatter(cell.row.original.createdOn)}</>;
            //   },
            // },
          ],
    []
  );
  const defaultColumn = useMemo(() => {
    return {
      Filter: ColumnFilter,
    };
  }, []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    // footerGroups,
    rows,
    page,
    nextPage,
    canNextPage,
    previousPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    state,
    setGlobalFilter,
    selectedFlatRows,
    setColumnOrder,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
  );
  const textareaRef = useRef();

  const { globalFilter, pageIndex, pageSize } = state;

  const [globalSearchValue, setGlobalSearchValue] = useState(globalFilter);

  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 1000);

  const deletUser = () => {
    // console.log({ selectedFlatRows });
  };
// console.log("kk",formik.errors.templateDesc)
  const getResellerSubUsers = async () => {
    try {
      setOpen(true);
      let res = await common_axios(
        `${process.env.REACT_APP_COMMON_API_SENDER_ID}/reseller/v1/reseller/users`
      );

      if (res.data.statusDescription.statusCode == 200) {
        const resellerObject = await {
          username: localStorage.getItem("usernamedisplayed"),
          uid: localStorage.getItem("UserId"),
        };
        await res.data.userList.unshift(resellerObject);
        setData1(res.data.userList);
        setOpen(false);
      } else {
        setOpen(false);

        // await toast.error(res.data.statusDescription.statusMessage, {
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      setOpen(false);

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  const getLaungauges = async () => {
    try {
      setOpen(true);
      let res = await common_axios(
        `${process.env.REACT_APP_COMMON_API_SENDER_ID}/admin/v1/language`
      );

      if (res.data.statusDescription.statusCode == 200) {
        if (res.data?.languages) setData2(res.data.languages);
        setOpen(false);
      } else {
        setOpen(false);

        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      setOpen(false);

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  useEffect(() => {
    getLaungauges();
    // getResellerSubUsers();
  }, []);

  const noOfVarUsed = (str) => {
    // console.log(str.split(" ").filter((x) => x == "#var#").length);
    return str.split(" ").filter((x) => x == "#var#").length;
  };
  return (
    <>
      <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
        <Backdrop
          sx={{
            transform: "translateZ(0)",
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
          // onClick={handleClose}
        >
          <Loader />
        </Backdrop>
        <ThemeProvider theme={theme}>
          <div className="container-fluid">
            <div className="card">
              <div className="card-header p-3 pt-2">
                <div className="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 p_static position-absolute">
                  <i className="material-icons ttl_icon opacity-10">person</i>
                </div>
                <div className="pt-1">
                  <p
                    className="text-md text_top mb-0 text-capitalize text-start fw-bold d-inline"
                    style={{ marginLeft: "70px" }}
                  >
                    Add Template
                  </p>
                  <p className="text-sm mb-0  text-capitalize d-inline-block float-end">
                    Field(s) marked with{" "}
                    <span className="text-danger fw-bold">*</span> are
                    mandatory.
                  </p>
                </div>
              </div>
              <div className="card-body">
                <div className="card shadow-none border bg_blue">
                  <span className="badge rounded-pill bg-primary mt-n3 ms-5">
                    Details
                  </span>

                  <div className="card-body text-lg-start text-center">
                    <form
                      onSubmit={formik.handleSubmit}
                      className="row g-3 needs-validation"
                      novalidate
                    >
                      <div className="col-md-4">
                        <FormControl required fullWidth>
                          <InputLabel size="small" id="test-select-label">
                            Select Type
                          </InputLabel>
                          <Select
                            size="small"
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={formik.values.selectValue}
                            label="Select Type"
                            onChange={(e) => {
                              formik.setFieldValue(
                                "selectValue",
                                e.target.value
                              );
                              // setSenderType(e.target.value);
                            }}
                          >
                            {[
                              {
                                id: 1,
                                name: "Promotional",
                                value: "Promotional",
                              },
                              {
                                id: 2,
                                name: "Transactional",
                                value: "Transactional",
                              },
                            ].map((d) => {
                              return (
                                <MenuItem value={d.value}> {d.name}</MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </div>
                      <div className="col-md-4">
                        <TextField
                          required
                          className="w-100"
                          label="Template Name"
                          name="templateName"
                          variant="outlined"
                          size="small"
                          type="text"
                          onInput={(e) => {
                            e.target.value = e.target.value
                              .toString()
                              .slice(0, 50);
                          }}
                          value={formik.values.templateName}
                          onChange={formik.handleChange}
                          error={
                            formik.touched.templateName &&
                            Boolean(formik.errors.templateName)
                          }
                          helperText={
                            formik.touched.templateName &&
                            formik.errors.templateName
                          }
                        />
                      </div>

                      <div className="col-md-4">
                        <FormControl required fullWidth>
                          <InputLabel size="small" id="test-select-label">
                            Select Type
                          </InputLabel>
                          <Select
                            size="small"
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={formik.values.selectLang}
                            label="Select Type"
                            onChange={(e) => {
                              formik.setFieldValue(
                                "selectLang",
                                e.target.value
                              );
                              formik.setFieldValue("templateDesc", "");
                            }}
                          >
                            {data2.map((d) => {
                              return (
                                <MenuItem key={d.id} value={d.lang}>
                                  {" "}
                                  {d.lang}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </div>

                      <div className="col-md-12 mt-3">
                        <label className="text-start">Template</label>
                        {/* {formik.values.templateType != "Dynamic" && ( */}
                        <TextareaAutosize
                          disabled={
                            formik.values.selectLang == "" ||
                            formik.values.selectLang == null
                          }
                          value={formik.values.templateDesc}
                          error={
                            formik.touched.templateDesc &&
                            Boolean(formik.errors.templateDesc)
                          }
                          helperText={
                            formik.touched.templateDesc &&
                            formik.errors.templateDesc
                          }
                          //   onBlur={formik.handleBlur}
                          onChange={(e) => {
                            if (formik?.values?.selectLang == "English") {
                              if (
                                /^[a-zA-Z0-9!@~#$%^&*()-_+=\[\]{};:'",.<>/?\\| ]*$/.test(
                                  e.target.value
                                )
                              ) {
                                formik.handleChange(e);
                              } else {
                                formik.setFieldError(
                                  "templateDesc",
                                  "Unicode not allowed in selected language"
                                );
                              }
                            } else {
                              formik.handleChange(e);
                            }
                          }}
                          onInput={(e) => {
                            e.target.value = e.target.value
                              .toString()
                              .slice(0,1000);
                          }}
                          // onBlur={formik.handleBlur}
                          required
                          name="templateDesc"
                          fullWidth
                          aria-label="minimum height"
                          minRows={5}
                          //   style={{ minHeight: "150px" }}
                          className={
                            formik.errors.templateDesc
                              ? "border-color-red w-100"
                              : "w-100"
                          }
                          placeholder="Enter Template"
                        />

                        {formik.errors.templateDesc && (
                          <p
                            className="MuiFormHelperText-root Mui-error MuiFormHelperText-sizeSmall MuiFormHelperText-contained MuiFormHelperText-filled Mui-required css-k4qjio-MuiFormHelperText-root"
                            style={{ color: "red" }}
                          >
                            {formik.errors.templateDesc}
                          </p>
                        )}
                        {/* )} */}
                        {/* {formik.values.templateType == "Dynamic" && (
                          <>
                            <TextareaAutosize
                              value={formik.values.templateDesc}
                              error={
                                formik.touched.templateDesc &&
                                Boolean(formik.errors.templateDesc)
                              }
                              helperText={
                                formik.touched.templateDesc &&
                                formik.errors.templateDesc
                              }
                              //   onBlur={formik.handleBlur}
                              onChange={(e) => {
                                console.log({ e });
                                formik.handleChange(e);
                                textareaRef.current.focus();
                              }}
                              ref={textareaRef}
                              onBlur={(e) => {
                                onBlur(e);
                                // setSelectionRange(e.target.selectionStart);
                                // setVariableUsed([...variableUsed, "#var#"]);
                              }}
                              id="textareaid"
                              required
                              name="templateDesc"
                              fullWidth
                              aria-label="minimum height"
                              minRows={5}
                              //   style={{ minHeight: "150px" }}
                              className={
                                formik.errors.templateDesc
                                  ? "border-color-red w-100"
                                  : "w-100"
                              }
                              placeholder="Template Here"
                            />

                            {formik.errors.templateDesc && (
                              <p
                                className="MuiFormHelperText-root Mui-error MuiFormHelperText-sizeSmall MuiFormHelperText-contained MuiFormHelperText-filled Mui-required css-k4qjio-MuiFormHelperText-root"
                                style={{ color: "red" }}
                              >
                                {formik.errors.templateDesc}
                              </p>
                            )}
                          </>
                        )} */}
                      </div>

                      {formik.values.templateType != "Dynamic" && (
                        <div className="col-md-12">
                          <pre>
                            <code>
                              <p>
                                Character length used:
                                {formik.values.templateDesc.length}
                              </p>

                              <p>Disclaimer: This is only estimated counts</p>
                              <p>
                                Number of message used:
                                {formik.values.selectLang == "English"
                                  ? parseInt(
                                      formik.values.templateDesc.length / 160 +
                                        1
                                    )
                                  : parseInt(
                                      formik.values.templateDesc.length / 70 + 1
                                    )}
                              </p>
                              <p style={{fontWeight:"bold"}}>
                               <span style={{color:"red", fontWeight:"bold"}} >
                                *
                              </span>
                              Only 1000 characters are allowed
                              </p>
                            </code>
                          </pre>
                        </div>
                      )}

                      {/* {formik.values.templateType == "Dynamic" && (
                        <div className="col-md-12">
                          <pre>
                            <code>
                              <p>
                                Character length used:
                                {formik.values.templateDesc.length}
                              </p>
                              <p>
                                Variable used:
                                {noOfVarUsed(formik.values.templateDesc)}
                              </p>
                              <p>Disclaimer: This is only estimated counts</p>
                              <p>
                                Number of message used:
                                {parseInt(
                                  formik.values.templateDesc.length / 160 + 1
                                )}
                              </p>
                             
                            </code>
                          </pre>
                        </div>
                      )} */}

                      <div className="text-end">
                        <button
                          type="submit"
                          className="btn bg-gradient-primary m-0"
                        >
                          Submit
                          <i className="material-icons opacity-10">
                            arrow_right_alt
                          </i>
                        </button>

                        <button
                          style={{ marginLeft: "6px" }}
                          type="button"
                          onClick={formik.handleReset}
                          className="btn bg-gradient-secondary m-0 ms-2"
                        >
                          Reset
                          <i className="material-icons opacity-10">
                            settings_backup_restore
                          </i>
                        </button>
                      </div>

                      {/* <div className="row">
                          <div className="col-md-3 mt-3">
                            <button className="btn btn-primary" type="submit">
                              Submit
                            </button>
                            <button
                              type="button"
                              onClick={formik.handleReset}
                              className="btn btn-secondary"
                            >
                              Reset
                            </button>
                          </div>
                        </div> */}
                    </form>
                  </div>
                </div>

                {data.length > 0 && (
                  <div className="card-body">
                    <div className="container-fluid p-0">
                      <div className="card shadow-none border bg_blue mt-5">
                        <span className="badge rounded-pill bg-primary mt-n3 ms-5 ">
                          Recently Added
                        </span>
                        <div className="p-4">
                          <div className="d-flex justify-content-between my-3">
                            <select
                              value={pageSize}
                              className="dropdown"
                              onChange={(e) => {
                                setPageSize(Number(e.target.value));
                              }}
                            >
                              {[10, 25, 50].map((value, i) => {
                                return (
                                  <option
                                    className="dropdown-menu"
                                    aria-labelledby="dropdownMenuButton1"
                                    value={value}
                                    key={value}
                                  >
                                    {" "}
                                    Show {value}
                                  </option>
                                );
                              })}
                            </select>

                            {/* <div></div>
                            <div className="d-flex align-items-center">
                              <TextField
                                className="ms-4"
                                style={{
                                  borderRadius: "4px",
                                }}
                                type="text"
                                label="Search"
                                name="Search"
                                variant="outlined"
                                // value={number}
                                size="small"
                                value={globalSearchValue || ""}
                                onChange={(e) => {
                                  onChange(e.target.value);
                                  setGlobalSearchValue(e.target.value);
                                }}
                              />
                            </div> */}
                          </div>

                          <div>
                            {selectedFlatRows.length > 0 && (
                              <button onClick={deletUser}>Delete Users</button>
                            )}
                          </div>
                          <div className="table-responsive">
                            <table
                              {...getTableProps()}
                              id="example"
                              className="table table-striped table-bordered dataTable table-sm"
                              style={{ width: "100%" }}
                            >
                              <thead>
                                {headerGroups.map((headerGroup) => (
                                  <tr {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map((column) => (
                                      <th
                                        {...column.getHeaderProps(
                                          column.getSortByToggleProps()
                                        )}
                                        className="text-center width_2"
                                      >
                                        {column.render("Header")}
                                        <span>
                                          {column.isSorted
                                            ? column.isSortedDesc
                                              ? "↑"
                                              : "↓"
                                            : ""}
                                        </span>
                                      </th>
                                    ))}
                                  </tr>
                                ))}
                              </thead>
                              <tbody {...getTableBodyProps()}>
                                {page.map((row) => {
                                  prepareRow(row);
                                  return (
                                    <tr {...row.getRowProps()}>
                                      {row.cells.map((cell) => {
                                        return (
                                          <td
                                            {...cell.getCellProps()}
                                            className="text-center"
                                          >
                                            {cell.render("Cell")}
                                          </td>
                                        );
                                      })}
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>

                          <div className="d-flex justify-content-between">
                            <div>
                              <span>
                                Page:
                                <strong>
                                  {pageIndex + 1} of {pageOptions.length}
                                </strong>
                              </span>
                            </div>

                            {/* <div>
                              <span>
                                Go to Page :{""}
                                <input
                                  type="number"
                                  // defaultValue={pageIndex + 1}
                                  value={pageIndex + 1}
                                  onChange={(e) => {
                                    const pageNumber = e.target.value
                                      ? Number(e.target.value) - 1
                                      : 0;
                                    gotoPage(pageNumber);
                                  }}
                                  style={{ width: "50px" }}
                                />
                              </span>
                            </div> */}

                            <div>
                              <button
                                className="btn btn_secondary me-3"
                                type="button"
                                disabled={!canPreviousPage}
                                style={{ background: "#2C97D4" }}
                                onClick={() => {
                                  previousPage();
                                }}
                              >
                                Prev
                              </button>

                              <button
                                className="btn btn_secondary "
                                type="button"
                                disabled={!canNextPage}
                                style={{ background: "#2C97D4" }}
                                onClick={() => {
                                  nextPage();
                                }}
                              >
                                Next
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <div className="d-flex mt-3 me-3 mb-3">
                  <div className="d-flex main_box">
                    <p className="fw-bold">View Templates</p>
                    <Link
                      to="/dashboard/MyTemplate"
                      style={{ color: "#63B7E6", marginLeft: "30px" }}
                    >
                      <span>Click here !!!</span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ThemeProvider>
      </main>
    </>
  );
}
